<div class="divider-container">
  <div class="new-messages-divider mat-body-strong bar"></div>
  <div class="mat-body-strong text">New</div>
  <div class="new-messages-divider mat-body-strong bar"></div>
</div>